import Image from 'next/image';
import logo from '../../assets/logo.svg';



export function Logo({ width, height }: { width?: number; height?: number }) {
  return (
    <Image
      src={logo}
      alt="moonpacket Logo"
      style={{ width: width || 'auto', height: height || 'auto' }}
      width={width || 48}
      height={height || 48}
    />
  );
}
